import api                from '@/api'
export default {
    data () {
        return {
          
            pricesList  : []
                             
        }
      },
      mounted: function() {
        
        this.getSapiaClubPricesList();
  },  
    methods: {

        getSapiaClubPrice(retailPrice)
        {
            let price 
            this.pricesList.forEach(item => {
                if(item.retailPrice==retailPrice)
                {
                    price = item.clubPrice
                }    
            });
            return price
        },
        async getSapiaClubPricesList()
            { 
              const sp   = {'sp' : 'spClubPriceList'}                      
              await api.post(sp).then(res => {
                if(res.status == 200)
                {
                  if(res.data.recordsets[0].length > 0)
                  {
                    
                    this.pricesList = res.data.recordsets[0]
                   // console.log(this.pricesList)
                    
                  }
                  
                }
              })

        },      

    }
    

}